'use client'
import Link from 'next/link';

interface ButtonProps {
  variant?: 'filled' | 'outlined';
  label: string;
  iconPosition?: 'none' | 'left' | 'right' | 'both';
  iconSrc?: string;
  disabled?: boolean;
  customClass?: string;
  href?: string;
  onClick?: () => void;
}

export default function Button({
  variant = 'filled',
  label = 'Click Me',
  iconPosition = 'none',
  iconSrc = '',
  disabled = false,
  customClass = '',
  href = '',
  onClick,
}: ButtonProps) {

  const variantClass = variant === 'filled' ? 'ds-btn--filled' : 'ds-btn--outlined';
  const iconClass =
    iconPosition === 'left' ? 'ds-btn--icon-left' :
    iconPosition === 'right' ? 'ds-btn--icon-right' :
    iconPosition === 'both' ? 'ds-btn--icon-both' : '';
  const disabledClass = disabled ? 'ds-btn--disabled' : '';
  const className = ['ds-btn', variantClass, iconClass, disabledClass, customClass]
    .filter(Boolean)
    .join(' ');

  const handleClick = () => {
    if (!disabled && onClick) onClick();
  };

  const iconLeft = (iconPosition === 'left' || iconPosition === 'both') && iconSrc && (
    <img src={iconSrc} className="ds-btn__icon" alt="" />
  );

  const iconRight = (iconPosition === 'right' || iconPosition === 'both') && iconSrc && (
    <img src={iconSrc} className="ds-btn__icon" alt="" />
  );

  if (href) {
    return (
      <Link href={href} className={className} onClick={handleClick}>
        {iconLeft}
        <span>{label}</span>
        {iconRight}
      </Link>
    );
  }

  return (
    <button className={className} disabled={disabled} onClick={handleClick}>
      {iconLeft}
      <span>{label}</span>
      {iconRight}
    </button>
  );
}
